const DAY_IN_MS = 86400000;

function formatDateISO(date) {
    return new Date(date).toISOString().substring(0, 10);
}

function durationInDays(startDate, endDate) {
    if (!startDate || !endDate) {
        return null;
    }
    const start = new Date(startDate);
    const end = new Date(endDate);
    return Math.round((end - start) / DAY_IN_MS) + 1;
}

function formatDateRange(startDate, endDate) {
    if (!startDate) {
        return "";
    }
    const opts = { day: "numeric", month: "short" };
    const start = new Date(startDate).toLocaleDateString("en-us", opts);
    if (!endDate) {
        return start;
    }
    const end = new Date(endDate).toLocaleDateString("en-us", {
        ...opts,
        year: "numeric",
    });
    return `${start} – ${end}`;
}

export { DAY_IN_MS, formatDateISO, durationInDays, formatDateRange };
